<template>
    <div class="doc-section">
        <h1>Administración de equipos de rastreo</h1>
         <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <p>
            Un equipo de rastreo, en adelante indicado como dispositivo, es el recurso principal del sistema, registra
            posiciones y puede enviar y recibir una serie de mensajes. Para visualizar la lista de dispositivos creados
            en el sistema, ir al menú y hacer clic sobre la opción Dispositivos. Se mostrará la pantalla principal con
            el listado de los dispositivos registrados.
        </p>

        <ol class="ul-contenedor step-list">
            <li>Campo buscar, permite filtrar los elementos de la tabla. </li>
            <li>Botón agregar dispositivo, permite ir a la vista del mismo nombre para registrar un nuevo usuario. </li>
            <li>Tabla con los dispositivos registrados en el sistema, que muestra el nombre de usuario, el rol del
                usuario y en acciones las opciones de editar y eliminar. </li>
        </ol>


        <div class="info-card">
            <p>
               <strong>Nota:</strong> El administrador podrá visualizar todos los dispositivos registrados por los usuarios de tipo
                administrador, mientras que el usuario final no tiene acceso a esta vista.
            </p>
        </div>

        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesDispositivo" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesDispositivoMoviles" />
        </div>

    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'ListadoDispostivo',
    components: { CarruselAciqui,plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesDispositivo: [
            {
                nombre: "Listado Dispositivos",
                url: "img/Dispositivos/listadoDispositivo.png",
                descripcion: "Lista de todos los dispositivos registrados en el sistema"
            }
        ],
        imagenesDispositivoMoviles: [
            {
                nombre: "Listado Dispositivos",
                url: "img/Dispositivos/moviles/listadoDispositivo.png",
                descripcion: "Lista de todos los dispositivos registrados en el sistema"
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>